import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";
import Activity from "../../models/Activity";

export default function ActivitiesManagementPage() {
    const location = useLocation();
    const successMessage = location.state?.successMessage;
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [activities, setActivities] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    // إعدادات الـ Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;

    const fetchActivities = async () => {
        setIsLoading(true);
        try {
            const res = await backEnd_request.get("/Activities", {
                params: {
                    q: searchTerm,
                    page: currentPage,
                    size: pageSize
                }
            });

            const { total, data } = res.data;
            setActivities(data.map(a => new Activity(a)));

            if (total) {
                setTotalPages(Math.ceil(total / pageSize));
            }
        } catch (error) {
            console.error("Fetch Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchActivities();
    }, [currentPage, searchTerm]);

    const handlePageChange = (p) => {
        if (p < 1 || p > totalPages) return;
        setCurrentPage(p);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDelete = async (activityId) => {
        if (window.confirm("هل أنت متأكد من حذف هذا النشاط؟")) {
            try {
                await backEnd_request.delete(`/Activities/${activityId}`);
                fetchActivities();
                setDeleteSuccessMessage("تم حذف النشاط بنجاح ✅");
                setTimeout(() => setDeleteSuccessMessage(""), 3000);
            } catch (error) {
                console.log(error.response?.data || error);
            }
        }
    };

    return (
        <div className="container py-5" style={{ maxWidth: '900px', direction: 'rtl' }}>

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-5">
                <h2 className="fw-black m-0 text-dark">إدارة النشاطات</h2>
                <button className="btn btn-dark rounded-pill px-4 fw-bold shadow-sm" onClick={() => navigate("/admin/activities-management/create")}>
                    + إضافة نشاط
                </button>
            </div>

            {/* Search */}
            <div className="mb-4">
                <div className="input-group bg-white rounded-4 shadow-sm border p-1">
                    <span className="input-group-text bg-transparent border-0 ps-3">
                        <i className="bi bi-search text-muted"></i>
                    </span>
                    <input
                        type="text"
                        className="form-control border-0 shadow-none py-3"
                        placeholder="ابحث عن نشاط..."
                        value={searchTerm}
                        onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                    />
                </div>
            </div>

            {/* List Content */}
            {isLoading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
            ) : (
                <div className="activities-list animate-fade-in mb-5">
                    {activities.length > 0 ? (
                        activities.map((act) => (
                            <div key={act.activityId} className="modern-row bg-white border rounded-4 p-3 mb-2 d-flex align-items-center justify-content-between shadow-sm transition-all">
                                <div className="d-flex align-items-center gap-4">
                                    <div className="count-capsule text-center bg-light border rounded-3 px-3 py-2">
                                        <span className="d-block h5 fw-black m-0">{act.establishmentsCount || 0}</span>
                                        <small className="text-muted fw-bold" style={{ fontSize: '0.6rem' }}>منشأة</small>
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-1 pointer-link fs-5" onClick={() => navigate(`/admin/establishments-list?activityType=${encodeURIComponent(act.activityType)}`)}>
                                            {act.activityType}
                                        </h6>
                                        <span className={`badge ${act.isActive ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'} border-0 rounded-pill px-3`}>
                                            {act.isActive ? "نشط" : "غير نشط"}
                                        </span>
                                    </div>
                                </div>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-outline-primary border-0 rounded-circle p-2" onClick={() => navigate(`/admin/activities-management/edit/${act.activityId}`)}>
                                        <i className="bi bi-pencil-square fs-5"></i>
                                    </button>
                                    <button className="btn btn-outline-danger border-0 rounded-circle p-2" onClick={() => handleDelete(act.activityId)}>
                                        <i className="bi bi-trash3 fs-5"></i>
                                    </button>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-5 bg-white rounded-4 border">لا توجد بيانات</div>
                    )}
                </div>
            )}

            {/* --- الترقيم المطور (نفس تصميم صفحة المنشآت) --- */}
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-5 gap-3 border-top pt-4">
                <div className="text-muted small order-2 order-md-1 fw-bold">
                    عرض الصفحة {currentPage} من أصل {totalPages}
                </div>
                <nav className="order-1 order-md-2">
                    <ul className="pagination pagination-sm mb-0 gap-1 flex-wrap justify-content-center">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button className="page-link rounded-circle border-0 shadow-sm mx-1 p-2 bg-white text-dark" onClick={() => handlePageChange(currentPage - 1)}>
                                <i className="bi bi-chevron-right px-1"></i>
                            </button>
                        </li>

                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(p => p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1)
                            .map((p, idx, arr) => (
                                <div key={p} className="d-flex align-items-center">
                                    {idx > 0 && arr[idx - 1] !== p - 1 && <span className="mx-1 text-muted">...</span>}
                                    <li className={`page-item ${currentPage === p ? 'active' : ''}`}>
                                        <button
                                            className={`page-link rounded-circle border-0 shadow-sm fw-bold mx-1 d-flex align-items-center justify-content-center ${currentPage === p ? 'bg-primary text-white' : 'bg-white text-dark'}`}
                                            style={{ width: '38px', height: '38px' }}
                                            onClick={() => handlePageChange(p)}
                                        >
                                            {p}
                                        </button>
                                    </li>
                                </div>
                            ))}

                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link rounded-circle border-0 shadow-sm mx-1 p-2 bg-white text-dark" onClick={() => handlePageChange(currentPage + 1)}>
                                <i className="bi bi-chevron-left px-1"></i>
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>

            <style>{`
                .fw-black { font-weight: 900; }
                .transition-all { transition: all 0.3s ease; }
                .modern-row:hover { transform: translateY(-3px); border-color: #0d6efd !important; box-shadow: 0 10px 20px rgba(0,0,0,0.05) !important; }
                .pointer-link:hover { color: #0d6efd !important; text-decoration: underline; }
                .page-link { transition: all 0.2s; cursor: pointer; }
                .page-link:hover:not(.bg-primary) { background-color: #f8f9fa !important; color: #0d6efd !important; }
                .animate-fade-in { animation: fadeIn 0.5s ease-in-out; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
}